import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

// WhatsApp Business (spec 2026-10-06). Tümü POST, yanıt { status, data }.
// Klinik: /api/clinic/whatsapp (whatsapp:manage | whatsapp:contacts); onay salt okunur (patients:read)
// Admin:  /api/admin/whatsapp (admin-clinics:read | admin-clinics:whatsapp)
const CLINIC = "/api/clinic/whatsapp";
const ADMIN = "/api/admin/whatsapp";

export const whatsappApi = createApi({
  reducerPath: "whatsappApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["WaStatus", "WaContacts", "WaContactThread", "WaOptIn", "WaAdmin"],
  keepUnusedDataFor: 30,
  endpoints: (b) => ({
    // ── Bağlantı (Klinik Yönetimi › WhatsApp) ──
    whatsAppStatus: b.query({
      query: (d) => apiFunction(d, `${CLINIC}/status`, "POST"),
      providesTags: ["WaStatus"],
    }),
    acceptWhatsAppDeclaration: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/accept-declaration`, "POST"),
      invalidatesTags: ["WaStatus"],
    }),
    connectWhatsApp: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/connect`, "POST"),
      invalidatesTags: ["WaStatus"],
    }),
    disconnectWhatsApp: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/disconnect`, "POST"),
      invalidatesTags: ["WaStatus"],
    }),
    syncWhatsAppTemplates: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/templates/sync`, "POST"),
      invalidatesTags: ["WaStatus"],
    }),

    // ── Yeni kişiler (Mesajlar) ──
    listWhatsAppContacts: b.query({
      query: (d) => apiFunction(d, `${CLINIC}/contacts/list`, "POST"),
      providesTags: ["WaContacts"],
    }),
    whatsAppContactThread: b.query({
      query: (d) => apiFunction(d, `${CLINIC}/contacts/thread`, "POST"),
      providesTags: ["WaContactThread"],
    }),
    // Daha eski sayfalar (önbelleğe alınmaz; sayfa kendi state'inde biriktirir)
    olderWhatsAppContactMessages: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/contacts/thread`, "POST"),
    }),
    sendWhatsAppContactMessage: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/contacts/send`, "POST"),
      invalidatesTags: ["WaContacts", "WaContactThread"],
    }),
    markWhatsAppContactRead: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/contacts/mark-read`, "POST"),
      invalidatesTags: ["WaContacts"],
    }),
    linkWhatsAppContact: b.mutation({
      query: (d) => apiFunction(d, `${CLINIC}/contacts/link`, "POST"),
      invalidatesTags: ["WaContacts", "WaContactThread"],
    }),

    // ── Hasta onayı ──
    whatsAppOptIn: b.query({
      query: (d) => apiFunction(d, `${CLINIC}/opt-in/get`, "POST"),
      providesTags: ["WaOptIn"],
    }),
    // ── Admin ──
    adminWhatsAppList: b.query({
      query: (d) => apiFunction(d, `${ADMIN}/list`, "POST"),
      providesTags: ["WaAdmin"],
    }),
    adminSuspendWhatsApp: b.mutation({
      query: (d) => apiFunction(d, `${ADMIN}/suspend`, "POST"),
      invalidatesTags: ["WaAdmin"],
    }),
    adminSyncWhatsAppTemplates: b.mutation({
      query: (d) => apiFunction(d, `${ADMIN}/templates/sync`, "POST"),
      invalidatesTags: ["WaAdmin"],
    }),
    adminUnsuspendWhatsApp: b.mutation({
      query: (d) => apiFunction(d, `${ADMIN}/unsuspend`, "POST"),
      invalidatesTags: ["WaAdmin"],
    }),
  }),
});

export const {
  useWhatsAppStatusQuery,
  useAcceptWhatsAppDeclarationMutation,
  useConnectWhatsAppMutation,
  useDisconnectWhatsAppMutation,
  useSyncWhatsAppTemplatesMutation,
  useListWhatsAppContactsQuery,
  useWhatsAppContactThreadQuery,
  useOlderWhatsAppContactMessagesMutation,
  useSendWhatsAppContactMessageMutation,
  useMarkWhatsAppContactReadMutation,
  useLinkWhatsAppContactMutation,
  useWhatsAppOptInQuery,
  useSetWhatsAppOptInMutation,
  useAdminWhatsAppListQuery,
  useAdminSuspendWhatsAppMutation,
  useAdminUnsuspendWhatsAppMutation,
  useAdminSyncWhatsAppTemplatesMutation,
} = whatsappApi;
